import _ from 'lodash';
import { i18n } from './i18n';
import pluralize from 'pluralize';
import { TAG_TYPE } from '@/constants';
import { modelData, getLabel } from '@/custom_models_extend';

export const linkTo = ({ item }) => {
  let name = `${pluralize(_.snakeCase(item.cn))}.show`

  if (item.tn === 'accounts') {
    name = (item.account_status === 'visitor' ? 'visitor_accounts.show' : 'formal_accounts.show')
  }

  return { name: name, params: { id: item.id } }
}

const beanLinkCan = ({ item }) => {
  let can = []

  if (item.tn === 'accounts') {
    can = 'accounts.read'
  }

  return can
}

const components = {
  id: function() {
    return {
      width: 80
    }
  },
  type: function({ k, filterColumnsExtend }) {
    let hash = {
      minWidth: 120,
      renderCell: (h, { props: { value } }) => {
        return <el-tag type='primary'>{i18n.t(`model.${modelData[value]['element']}`)}</el-tag>;
      },
    }

    if (filterColumnsExtend) {
      let [eqFilter] = filterColumnsExtend([`${k}_eq`])

      if (eqFilter) {
        eqFilter.label = '等于'
        hash['filterColumns'] = [eqFilter]
      }
    }

    return hash
  },
  attached: function() {
    return {
      width: 120,
      renderCell: 'storageAttachment',
    }
  },
  belongsTo: function({ k, filterColumnsExtend }) {
    let hash = {
      minWidth: 120,
      renderCell: (h, { props: { value } }) => {
        if (value) {
          return <bean-link keepNode to={linkTo({ item: value })} can={beanLinkCan({ item: value })}>{getLabel({ item: value })}</bean-link>
        } else {
          return <span>/</span>
        }
      },
    }

    if (filterColumnsExtend) {
      let [eqFilter] = filterColumnsExtend([`${k}_id_eq`])

      if (eqFilter) {
        eqFilter.label = '等于'
        hash['filterColumns'] = [eqFilter]
      }
    }

    return hash
  },
  hasOne: function() {
    return {
      minWidth: 120,
      renderCell: (h, { props: { value } }) => {
        if (value) {
          return <bean-link keepNode to={linkTo({ item: value })}  can={beanLinkCan({ item: value })}>{getLabel({ item: value })}</bean-link>
        } else {
          return <span>/</span>
        }
      },
    }
  },
  hasMany: function() {
    return {
      renderCell: (h, { props: { value } }) => {
        if (value.length) {
          return _.map(value, (object) => <div><bean-link keepNode to={linkTo({ item: object })}  can={beanLinkCan({ item: value })}>{getLabel({ item: object })}</bean-link></div>)
        } else {
          return <span>/</span>
        }
      }
    }
  },
  enum: function({ k, v, filterColumnsExtend }) {
    let hash = {
      minWidth: 100,
      renderCell: (h, { props: { value } }) => {
        if (!value) {
          return <span>/</span>
        }
        return <el-tag type={TAG_TYPE[value]}>{i18n.t(`${modelData[v.model_name]['element']}.${pluralize(_.camelCase(k))}.${value}`)}</el-tag>;
      },
    }

    if (filterColumnsExtend) {
      let [eqFilter] = filterColumnsExtend([`${k}_eq`])

      if (eqFilter) {
        eqFilter.label = '等于'
        hash['filterColumns'] = [eqFilter]
      }
    }

    return hash
  },
  string: function({ k, filterColumnsExtend }) {
    let hash = {
      minWidth: 120
    }

    if (filterColumnsExtend) {
      let [eqFilter, contFilter] = filterColumnsExtend([`${k}_eq`, `${k}_cont`])

      if (contFilter) {
        contFilter.label = '包含'
        hash['filterColumns'] = [contFilter]
      }

      if (eqFilter) {
        eqFilter.label = '等于'
        hash['filterColumns'] = hash['filterColumns'] ? hash['filterColumns'] : []
        hash['filterColumns'].push(eqFilter)
      }
    }

    return hash
  },
  integer: function () {
    return {
      minWidth: 100
    }
  },
  decimal: function () {
    return {
      minWidth: 100
    }
  },
  float: function () {
    return {
      minWidth: 100
    }
  },
  text: function () {
    return {
      minWidth: 120,
      align: 'left',
      renderCell: (h, { props: { value } }) => {
        if (!value) {
          return '<span>/</span>'
        }
        return <span style="white-space: pre-wrap; word-break: break-all">{value}</span>
      },
    }
  },
  boolean: function ({ k, filterColumnsExtend }) {
    let hash = {
      minWidth: 100,
      renderCell: 'bool'
    }

    if (filterColumnsExtend) {
      let [eqFilter] = filterColumnsExtend([`${k}_eq`])

      if (eqFilter) {
        eqFilter.label = '等于'
        hash['filterColumns'] = [eqFilter]
      }
    }

    return hash
  },
  date: function ({ k, filterColumnsExtend }) {
    let hash = {
      minWidth: 100,
      renderCell: 'date'
    }

    if (filterColumnsExtend) {
      let [gteqFilter, lteqFilter] = filterColumnsExtend([`${k}_gteq`, `${k}_lteq`])

      if (gteqFilter) {
        gteqFilter.label = '大于等于'
        hash['filterColumns'] = [gteqFilter]
      }

      if (lteqFilter) {
        lteqFilter.label = '小于等于'
        hash['filterColumns'] = hash['filterColumns'] ? hash['filterColumns'] : []
        hash['filterColumns'].push(lteqFilter)
      }
    }

    return hash
  },
  time: function () {
    return {
      renderCell: 'time'
    }
  },
  datetime: function () {
    return {
      minWidth: 140,
      renderCell: 'time',
    }
  },
  tag: function() {
    return {
      minWidth: 150,
      renderCell: (h, { props: { value } }) => {
        if (value.length) {
          return _.map(value, (object) => <el-tag style={{ 'margin-right': '3px' }}>{object}</el-tag>)
        } else {
          return <span>/</span>
        }
      },
    }
  }
}

export default function(columns, filterColumnsExtend) {
  let hash = {}

  _.forEach(columns, (v, k) => {
    if (v.column_type && components[_.camelCase(v.column_type)]) {
      hash[k] = _.merge({
        prop: v.prop || k,
        label: i18n.t(`${modelData[v.model_name]['element']}.${_.camelCase(k)}`),
      }, components[_.camelCase(v.column_type)]({ k, v, filterColumnsExtend }))
    } else {
      components.string({ filterColumnsExtend })
    }
  })

  return hash
}
